import {
  brandBgDataFile,
  BrandBgDataFile,
  brandBgDataHeight,
  BrandBgDataHeight,
  brandBgDataWidth,
  BrandBgDataWidth,
  brandEntityId,
  BrandEntityId,
  RoomId,
  roomId
} from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandBgCreate2VO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandBgCreate2VO.validationSchema()
  );

  constructor(readonly value: RoomBrandBgCreate2) {
    JsonSchemaValidator.assert(RoomBrandBgCreate2VO.validation, value);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "brandId", "data", "width", "height"],
      properties: {
        roomId,
        brandId: brandEntityId,
        data: brandBgDataFile,
        width: brandBgDataWidth,
        height: brandBgDataHeight
      },
      additionalProperties: false
    };
  }
}

interface RoomBrandBgCreate2 {
  roomId: RoomId;
  brandId: BrandEntityId;
  data: BrandBgDataFile;
  width: BrandBgDataWidth;
  height: BrandBgDataHeight;
}
